export enum EventCategoryEnum {
    ANIMATION = 'ANIMATION',
    WORKSHOP = 'WORKSHOP',
    CONCERT = 'CONCERT',
    EVENT = 'EVENT',
    FOOD_AND_WINE = 'FOOD_AND_WINE',
    FITNESS = 'FITNESS'
  }